import { Moment } from "moment";
import Utils from "../utils";
import { SyncModel, SyncDataModel, DataModel } from "./syncModel";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { TermViewModel } from "./term.model";

export class ImpressumTermViewModel {
  public id: number; //Impressum has the id -1 to avoid collision with term ids
  public get label(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.labelEN) ? this.labelDE : this.labelEN;
  }
  public labelDE: string;
  public labelEN: string;
  public get termHtmlContent(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.termHtmlContentEN) ? this.termHtmlContentDE : this.termHtmlContentEN;
  }
  public termHtmlContentDE: string;
  public termHtmlContentEN: string;
  public sortNumber: number;
}

// Requests
export class ImpressumSyncModel extends SyncModel {
}

// Responses

/** Only one impressum exists and it has the id=0 (this const is used for selecting the impressum) */
export const ImpressumDMKey: number = 0;

export class ImpressumDataModel extends DataModel {
  public get DM_Key(): number | string { return this.id; } // only ImpressumDMKey
  public id: number; // only ImpressumDMKey
  public text_html_de: string;
  public text_html_en: string;
  public change_at_ymd: number;
  public change_at_hms: number;
  public get change_at(): Moment {
    return Utils.GetMomentFromInt(this.change_at_ymd, this.change_at_hms);
  }
  public change_by: number;
}

export class ImpressumSyncDataModel extends SyncDataModel {
  public impressum: ImpressumDataModel[];
  public get models(): DataModel[] { return this.impressum; }
  public DeserializeType(): void {
    this._DeserializeType(ImpressumDataModel);
  }
}
